/* eslint-disable max-len */
import {
  OperationLaborTimeItem,
  OperationPartItem,
  PlateLine,
} from '@1po/1po-bff-fe-spec/generated/catalog/easy_basket/response/GetEasyBasketOperationDetailResponse';
import { Operation } from '@1po/1po-bff-fe-spec/generated/catalog/easy_basket/response/GetEasyBasketOperationsResponse';
import { APP_NAMESPACE } from 'app/App.constants';
import { SearchData } from 'utils';

export const EASY_BASKET_NAMESPACE = `${APP_NAMESPACE}/EASY_BASKET`;

export const GET_OPERATIONS_REQUEST = `${EASY_BASKET_NAMESPACE}/GET_OPERATIONS_REQUEST`;
export const GET_OPERATION_DETAILS_REQUEST = `${EASY_BASKET_NAMESPACE}/GET_OPERATION_DETAILS_REQUEST`;

export const TAB_PARTS_SELECTION = 'parts_selection';
export const TAB_SELECT_OPERATION = 'select_operation';
export const TAB_LABOR_RATE_SELECTION = 'labor_rate_selection';

export const BRAND_ORIGINAL_PARTS = 'original_parts';
export const BRAND_STANDARD_EXCHANGE = 'STANDARD_EXCHANGE';
export const BRAND_MOTRIO = 'MOTRIO';
export const BRAND_VALUE_PLUS = 'VALUE_PLUS';

export type EasyBasketTabs =
  | typeof TAB_PARTS_SELECTION
  | typeof TAB_SELECT_OPERATION
  | typeof TAB_LABOR_RATE_SELECTION
  | undefined;

export interface EasyBasketState {
  operations: Map<string, SearchData<Operation>>;
  operationDetails: Map<string, SearchData<OperationDetail>>;
  referenceSelection: Map<string, OperationReference>;
  referenceSelectionDisabled: Map<string, OperationReference>;
  laborTimeSelection: Map<string, OperationLaborTime>;
  selectedOperation: string;
}

export interface OperationItemPrice {
  priceVatIncluded: string;
  priceVatExcluded: string;
  currency: string;
}

export interface OperationReference {
  mainReferenceNumber: string;
  referenceNumber: string;
  quantity: number;
  price: OperationItemPrice | undefined;
}

export interface OperationLaborTime {
  laborTimeId: string;
  operationType?: string;
  price: OperationItemPrice | undefined;
}

export interface OperationDetail {
  id: string;
  basketContent: OperationBasketContent;
}

export interface OperationBasketContent {
  laborTimeSection: OperationLaborTimeSection;
  partsSection: OperationPartsSection;
}

export interface OperationLaborTimeSection {
  laborTimeItems: OperationLaborTimeItem[];
}

export interface OperationPartsSection {
  partsItems: OperationPartItem[];
  plateLines: Map<string, PlateLine>;
}
